<template>
    <div id="card" class="qb-padding" style="min-height: 312px;">
        <div v-if="dateFinal[0].daysExpired !== null && dateFinal[0].daysExpired >= 0">
            <p v-if="dateFinal[0].daysExpired < 1" class="qb-txt-back-warning">
                Seu carrinho expira hoje.
            </p>
            <p v-else>
                restam somente {{ dateFinal[0].daysExpired }} dia<span v-if="dateFinal[0].daysExpired !== 1">s</span> para o carrinho expirar.
            </p>
        </div>

        <vue-element-loading :active="this.show"/>
        <div style="display: flex; align-items: center; justify-content: space-between" v-scroll="handleScroll">
            <button class="btn btn-primary" @click="Conclude" style="width: 150px;height: 40px;display: flex;align-items: center;justify-content: space-between; order: 2">Fechar pedido<TruckDelivery class="md-28 white"/></button>
            <button class="btn btn-primary qb-shadow-1" v-if="exibirBotao" @click="Conclude" style="position: fixed; width: 150px; height: 40px; right: 15px; bottom: 55px;display: flex;align-items: center;justify-content: space-between;"><span>Fechar pedido {{ priceFormater(total) }}</span><TruckDelivery style="margin-right: 2px;" class="md-28 white"/></button>
            <p class="qb-txt-xl qb-txt-color-price qb-txt-bold">Total {{ priceFormater(total) }} </p>
        </div>
    <table>
    <thead>
        <tr>
            <th>#</th>
            <th @click="ordernarIndice()">Código</th>
            <th>Foto</th>
            <th @click="ordernarIndiceNome()">Descrição</th>
            <th>Embalagem</th>
            <th>Peças p/ Caixa</th>
            <th>Preço Lojista</th>
            <th>Preço Sugerido </th>
            <th>Quantidade</th>
            <th>Total</th>
            <th>Ações</th>
        </tr>
    </thead>
    <transition-group name="slide" tag="tbody" mode="out-in" >
        <tr v-for="(produto, index) in produtos" :key="produto.productId">
            <td data-label="#">{{ index + 1}}</td>
            <td data-label="Código">{{ produto.productId }}</td>
            <td data-label="Foto">
                <!-- <carousel :autoplay="false" :nav="false" :items="1" v-if="produto.images.length">
                    <img v-for="(imagem, index) in produto.images" :key="index" :src="imagem" alt="foto produto" style="max-width: 100%;max-height: 80px;min-height: 80px;"/>
                </carousel>
                <img v-else src="@/assets/sem-foto.png" alt="foto produto" style="max-width: 100%;max-height: 80px;min-height: 80px;"/> -->
                <img v-if="produto.images.length" :src="produto.images[0]" style="max-width: 100%;max-height: 80px;min-height: 80px;" alt="foto produto"/> 
                <img v-else src="@/assets/sem-foto.png" alt="foto produto" />
            </td>
            <td data-label="Descrição">{{ formatarDescricao(produto.description) }}</td>
            <td data-label="Embalagem">N/A</td>
            <td data-label="Peças p/ Caixa">N/A</td>
            <td data-label="Preço Lojista">{{ priceFormater(produto.discountPrice) }}</td>
            <td data-label="Preço Sugerido">{{priceFormater( parseInt(produto.unitaryPrice + (produto.unitaryPrice * ( ( !produto.suggestionPrice || produto.suggestionPrice == '' || produto.suggestionPrice == 0 ? 20 : produto.suggestionPrice) / 100))) + 1)}}</td>

            <td data-label="Quantidade">
                <InputCarrinho :produto="produto" @atualizaTotal="TotalPedido()"/>
            </td>
            <td data-label="Total" class="TotalProduto">{{ priceFormater(produto.discountPrice * produto.quantity) }}</td>
            <td data-label="Ações"><div class="acoes" @click="remove(produto,index)">Remover</div></td>
        </tr>   
    </transition-group>
    </table>
    <transition name="slide" mode="out-in" >
        <p v-if="this.total == 0">sem itens no carrinho</p>
    </transition>
</div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, userKey } from "@/global";
// import Imagem from "./imagem.vue";
import InputCarrinho from "./input-carrinho.vue";
import TruckDelivery from "vue-material-design-icons/TruckDelivery.vue";
import Trash from "vue-material-design-icons/TrashCan.vue";
import VueElementLoading from 'vue-element-loading';
// import { FadeTransition   } from 'vue2-transitions';
export default {
    components:{
        // Imagem,
        TruckDelivery,
        Trash,
        VueElementLoading,
        // FadeTransition,
        InputCarrinho
    },
    props:['adiciona' ],
    mounted(){
        const userData = JSON.parse(localStorage.getItem('vendedor'));
        const logado = JSON.parse(localStorage.getItem(userKey));

        var id = (userData && userData.typeAccess == "V" && logado.typeAccess == "V" ? logado.idCliente : 0);
        // Recuperando o item do localStorage
        let clienteUsuarioVinculado = localStorage.getItem('cliente_usuario_vinculado');
        var idClientUser = 0;
        if (clienteUsuarioVinculado) {
            // Convertendo a string JSON de volta para um objeto
            clienteUsuarioVinculado = JSON.parse(clienteUsuarioVinculado);
            
            // Exibindo apenas o ID no console
            idClientUser = clienteUsuarioVinculado.id;
        }

        var vendedorID = 0;
        const jsonVendedor = JSON.parse(localStorage.getItem('vendedor'));
        if (jsonVendedor) {
            vendedorID = jsonVendedor.codeVendedor;
        }
        
       

        axios.get(`${baseApiUrl}/orders/cart/${id}/${idClientUser}/${vendedorID}`)
        .then(res => {
            this.produtos = res.data;
            this.TotalPedido();
            this.show=false;
        });

        this.datefinal(id, idClientUser, vendedorID);
    },
    data(){
        return{
            produtos:[],
            total: 0,
            esconder: true,
            ordenado: false,
            ordenadoNome: false,
            exibirBotao: false,
            show:true,
            atualizandoQuantidadeProduto: false,
            dateFinal:[]
        }
    },
    methods:{
        handleScroll(/*evt, el*/){
            if(window.scrollY > 336){
                this.exibirBotao = true;
            }else{
                this.exibirBotao = false;
            }
        },
        

        datefinal(id, idClientUser, vendedorID) {
            console.log('Iniciando a chamada para date');
            axios.get(`${baseApiUrl}/orders/cartdate/${id}/${idClientUser}/${vendedorID}`)
                .then(res => {
                    this.dateFinal = res.data;
                    console.log('Data recebida:', this.dateFinal); // Mostra a data após ser recebida e atribuída
                })
                .catch(error => {
                    console.error('Erro ao obter data:', error);
                });
        },

        priceFormater(discountPrice){
            return discountPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },

        formatarDescricao(descricao){
            return descricao.substring(0,27)
        },


        formatarData(dateString) {
            const formattedDate = dateString.slice(0, 10); // Pegar os primeiros 10 caracteres
            const [year, month, day] = formattedDate.split('-');
            return `${day}/${month}/${year}`;
        },

        remove(produto, index) {
    console.log(`Deleting product with ID: ${produto.id} at index: ${index}`);
    axios.delete(`${baseApiUrl}/orders/${produto.id}`)
        .then(() => {
            console.log('Delete request successful');
            console.log('Before removal:', this.produtos);
            this.produtos.splice(index, 1);
            console.log('After removal:', this.produtos);
            this.TotalPedido();

            // Verifica se o carrinho está vazio
            if (this.produtos.length === 0) {
                console.log('Cart is empty. Redirecting to home page.');
                this.$router.push({ path: '/' });
            }
        })
        .catch(error => {
            console.error('Error during delete request:', error);
            this.$awn.warning(error);
        });
},
        
        ordernarIndice(){
            /* order lista */
            this.ordenado = !this.ordenado;
            this.produtos.sort((a, b) =>{
                if(!this.ordenado){
                    return a.productId.localeCompare(b.productId);
                }
                return b.productId.localeCompare(a.productId);
            })
        },
        ordernarIndiceNome(){
            /* order lista */
            this.ordenadoNome = !this.ordenadoNome;
            this.produtos.sort((a, b) =>{
                if(!this.ordenadoNome){
                    return a.description.localeCompare(b.description);
                }
                return b.description.localeCompare(a.description);
            })
        },
        TotalPedido(){
            this.total = 0;
            this.produtos.forEach(produto => {
                this.total += produto.quantity * produto.discountPrice;
            });
        },       
        Conclude(){
            const json = localStorage.getItem(userKey);
            const userData = JSON.parse(json);
            const json2 = localStorage.getItem('vendedor');
            const vendedor = JSON.parse(json2);

            // Recuperando o item do localStorage
            let clienteUsuarioVinculado = localStorage.getItem('cliente_usuario_vinculado');
                
            if (clienteUsuarioVinculado) {
                // Convertendo a string JSON de volta para um objeto
                clienteUsuarioVinculado = JSON.parse(clienteUsuarioVinculado);
                
                // Exibindo apenas o ID no console
                var idClientUser = clienteUsuarioVinculado.id;
            }

            var vendedorID = 0;

            
            const jsonVendedor = JSON.parse(localStorage.getItem('vendedor'));

            if (jsonVendedor) {
                vendedorID = jsonVendedor.codeVendedor;
            }
            

            let usr = {
                    id : userData.idCliente,
                    customerId : userData.idCliente,
                    login : userData.login     
                };

            

        axios.post(`${ baseApiUrl }/orders/conclude/${idClientUser}/${vendedorID}`, usr)
        .then(resp =>{
            if(resp.data.valid){
                this.$awn.success(resp.data.message, {labels: {success: resp.data.title }})
            }else{
                this.$awn.warning(resp.data.message, {labels: {warning: resp.data.title }})
            }
        })
        // .catch(error)
        .finally(this.$router.push({ path: '/' }));
        }
    },
    directives: {
        scroll: {
            inserted: function (el, binding) {
                let f = function (evt) {
                if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
                }
                }
                window.addEventListener('scroll', f)
            }
        }
    }
}
</script>

<style scoped>

.esconder{
    display: none;
}

table {
    border: 1px solid #ccc;
    width: 100%;
    margin:0;
    padding:0;
    border-collapse: collapse;
    border-spacing: 0;
  }

  table tr {
    border: 1px solid #ddd;
    padding: 5px;
    background: #fff;

  }

  table th, table td {
    padding: 10px 5px 10px 5px;
    text-align: center;

  }

  table th {
    text-transform: uppercase;
    letter-spacing: 1px;
  }

 

    .acoes{
        text-transform: uppercase;
        cursor:pointer;
    }

  @media screen and (max-width: 600px) {

   #card{
       width: 100%;
   }   
   #card table {
      border: 0;
    }

   #card table thead {
      display: none;
    }

   #card table tr {
        margin-bottom: 20px;
        display: block;
        border-bottom: 2px solid #ddd;
        box-shadow: 2px 2px 1px #dadada;
    }

   #card table td {
      display: block;
      text-align: right;
      font-size: 13px;
    }

   #card table td:last-child {
      border-bottom: 0;
    }

   #card table td::before {
      content: attr(data-label);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }

    td:nth-child(even) {
        background-color: #f2f2f2
    }

    /* .quantidade{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-grow: 2;
    } */

    td [data-label="Quantidade"]{
        background-color: red;
    }
    
  }
@media screen and (min-width: 600px) {
    tr:nth-child(2n+2) {
    background: #f8f8f8;
    }
    #card{
        width: 100%;
        overflow: auto;
    }
}


/* remover botoes padrao input number */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}




/*
animacao remocao tabela.
*/

/* @keyframes slide-in {
    from { transform: translateX(40px) }
    to { transform: translateY(0) }
}

@keyframes slide-out {
    from { transform: translateY(0) }
    to { transform: translateY(40px) }
} */


@keyframes slide-in {
    from { transform: translateX(-160px); }
    to { transform: translateY(0) }
}

@keyframes slide-out {
    from { transform: translateY(0) }
    to { transform: translateX(-160px); }
}


.slide-enter-active{
    animation: slide-in 0.5s ease;
	transition: opacity 0.5s;
}

.slide-leave-active {
    animation: slide-out 0.5s ease;
    transition: opacity 0.5s;
}

.slide-enter, .slide-leave-to{
    opacity: 0;
}
.slide-move{
	transition: transform 0.5s;
}
</style>
